import { DatePicker, InputNumber } from 'antd';
import { IconCoins } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { SlaCurrencySelect } from '~/app/landing/sla/shared/components/SlaCurrencySelect';
import { SlaFormField } from '~/app/landing/sla/shared/components/SlaFormField';
import { SlaLabeledSelect } from '~/app/landing/sla/shared/components/SlaLabeledSelect';
import { SlaModalFieldGrid } from '~/app/landing/sla/shared/components/SlaModalFieldGrid';
import {
  SLA_PAYMENT_MODEL_SELECT_OPTIONS,
  SLA_STATUS_SELECT_OPTIONS,
} from '~/app/landing/sla/shared/utils/sla-select-options';

export function LandlordPartnerContractFields() {
  const { t } = useTranslation('sla');

  return (
    <SlaModalFieldGrid columns={3}>
      <SlaFormField name="uptimeTargetPct" label={t('landlords.fields.uptime')}>
        <InputNumber min={0} max={100} style={{ width: '100%' }} />
      </SlaFormField>
      <SlaFormField
        name="responseDcDays"
        label={t('landlords.fields.responseDc')}
        rules={[{ required: true, message: t('validation.required') }]}
      >
        <InputNumber min={0.01} style={{ width: '100%' }} />
      </SlaFormField>
      <SlaFormField
        name="responseAcDays"
        label={t('landlords.fields.responseAc')}
        rules={[{ required: true, message: t('validation.required') }]}
      >
        <InputNumber min={0.01} style={{ width: '100%' }} />
      </SlaFormField>
      <SlaFormField
        name="penaltyPerDayAmount"
        label={t('landlords.fields.penalty')}
        rules={[{ required: true, message: t('validation.required') }]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </SlaFormField>
      <SlaFormField
        name="penaltyCurrency"
        label={
          <span
            style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
          >
            <IconCoins size={16} />
            {t('landlords.fields.penaltyCurrency')}
          </span>
        }
        rules={[{ required: true, message: t('validation.required') }]}
      >
        <SlaCurrencySelect style={{ width: '100%' }} />
      </SlaFormField>
      <SlaFormField
        name="paymentModel"
        label={t('landlords.fields.paymentModel')}
        rules={[{ required: true, message: t('validation.required') }]}
      >
        <SlaLabeledSelect
          style={{ width: '100%' }}
          options={SLA_PAYMENT_MODEL_SELECT_OPTIONS}
          translationPrefix="paymentModel"
        />
      </SlaFormField>
      <SlaFormField
        name="status"
        label={t('landlords.fields.status')}
        rules={[{ required: true, message: t('validation.required') }]}
      >
        <SlaLabeledSelect
          style={{ width: '100%' }}
          options={SLA_STATUS_SELECT_OPTIONS}
          translationPrefix="status"
        />
      </SlaFormField>
      <SlaFormField
        name="validFrom"
        label={t('landlords.fields.validFrom')}
        rules={[{ required: true, message: t('validation.required') }]}
      >
        <DatePicker style={{ width: '100%' }} />
      </SlaFormField>
      <SlaFormField name="validTo" label={t('landlords.fields.validTo')}>
        <DatePicker style={{ width: '100%' }} />
      </SlaFormField>
    </SlaModalFieldGrid>
  );
}
